module.exports = __webpack_public_path__ + "static/media/icon_zakctake_home.e92214f9.png";